<template>
    <div class="form section-b dealer-form" style="position: relative;">
        <div class="section-subhead">
            <i v-if="locked" class="fa fa-lock" style="padding: 0 0.25em 0 0; cursor: pointer;" @click="showLockedReason()"></i>
            Section B - Transferee / Buyer Info
        </div>
		<div class="section-b-detail">

			<h2 v-if="spanishLanguage" class="small">Nombre del Adquiriente / Comprador</h2>
			<h2 v-else class="small">Transferee / Buyer Name</h2>
			<div>
				<label v-if="spanishLanguage" ref="first_name">Nombre</label>
				<label v-else ref="first_name">First Name</label>
				<div class="two-columns media-two-columns">
					<input type="text" v-model="form.form_data.section_b.first_name" :maxlength="form.form_data.section_b.first_initial ? 1 : 60"/>
					<checkbox v-model="form.form_data.section_b.first_initial" :label="spanishLanguage ? 'Solo Una Inicial' : 'Initial Only'" style="margin: 0.5em 0;" :key="'fi_' + form.form_data.section_b.first_initial" />
				</div>
			</div>
			<div>
				<label v-if="spanishLanguage" ref="middle_name">Segundo nombre</label>
				<label v-else ref="middle_name">Middle Name</label>
				<div class="two-columns media-two-columns">
					<input type="text" v-model="form.form_data.section_b.middle_name" :maxlength="(form.form_data.section_b.no_middle_name ? 0 : (form.form_data.section_b.middle_initial ? 1 : 60))"/>
					<div class="one-two-columns">
						<div>
							<checkbox v-model="form.form_data.section_b.middle_initial" :label="spanishLanguage ? 'Solo Una Inicial' : 'Initial Only'" style="margin: 0.5em 0;" :key="'io_' + (form.form_data.section_b.middle_initial ? '1' : '0')" />
						</div>
						<div>
							<checkbox v-model="form.form_data.section_b.no_middle_name" :label="spanishLanguage ? 'Sin Segundo Nombre' : 'No Middle Name'" style="margin: 0.5em 0;" :key="'nmn_' + (form.form_data.section_b.no_middle_name ? '1' : '0')" />
						</div>
					</div>
				</div>
			</div>
			<div>
				<div class="two-columns media-two-columns">
					<div class="three-one-columns">
						<label v-if="spanishLanguage" ref="last_name">Apellido</label>
						<label v-else ref="last_name">Last Name</label>
						<label v-if="spanishLanguage" ref="last_name">Sufijo</label>
						<label v-else ref="last_name">Suffix</label>
						<input type="text" v-model="form.form_data.section_b.last_name" :maxlength="form.form_data.section_b.last_initial ? 1 : 60"/>
						<select v-model="form.form_data.section_b.suffix">
							<option value="">Select...</option>
							<option value="II" title="">II</option>
							<option value="III" title="">III</option>
							<option value="IV" title="">IV</option>
							<option value="V" title="">V</option>
							<option value="VI" title="">VI</option>
							<option value="VII" title="">VII</option>
							<option value="VIII" title="">VIII</option>
							<option value="IX" title="">IX</option>
							<option value="X" title="">X</option>
							<option value="JR" title="">Jr</option>
							<option value="SR" title="">Sr</option>
						</select>
					</div>
					<checkbox v-model="form.form_data.section_b.last_initial" :label="spanishLanguage ? 'Solo Una Inicial' : 'Initial Only'" style="margin: 0.5em 0;" />
				</div>
			</div>

			<div style="margin: 1em 0 0 0;">
				<h2 v-if="spanishLanguage">Actual Dirección de Residencia (No puede ser un apartado de correo)</h2>
				<h2 v-else class="small">Current Address (Cannot be a PO Box)</h2>

				<div class="section-b-address section-b-section three-columns media-three-two-columns">
					<div>
						<label ref="address_1" v-if="spanishLanguage">Dirección (calle y número)</label>
						<label ref="address_1" v-else>Number and Street Address</label>
						<input type="text" v-model="form.form_data.section_b.address_1"/>
					</div>
					<div>
						<label ref="city" v-if="spanishLanguage">Ciudad</label>
						<label ref="city" v-else>City</label>
						<input type="text" v-model="form.form_data.section_b.city"/>
					</div>
					<div>
						<label ref="county" v-if="spanishLanguage"><b>Condado</b> / Municipalidad / Barrio</label>
						<label ref="county" v-else><b>County</b> / Parish / Borough</label>
						<input type="text" v-model="form.form_data.section_b.county"/>
					</div>
					<div>
						<label ref="state" v-if="spanishLanguage">Estado</label>
						<label ref="state" v-else>State</label>
						<state-select type="text" v-model="form.form_data.section_b.state" :showApo="true" :showProvinces="true" placeHolder="Select..." ></state-select>
					</div>
					<div>
						<label ref="zip_code" v-if="spanishLanguage">Código postal</label>
						<label ref="zip_code" v-else>Zip Code</label>
						<input type="text" v-model="form.form_data.section_b.zip_code"/>
					</div>
					<div>
						<label ref="in_city_limits" v-if="spanishLanguage">¿Reside en los límites de la ciudad?</label>
						<label ref="in_city_limits" v-else>In City Limits?</label>
						<binary-toggle v-model="form.form_data.section_b.in_city_limits" :tertiary="true" :labels="spanishLanguage ? 'Sí,No,Desconocido' : 'Yes,No,Unknown'" style="margin-top: 0.5em;" :key="'icl_' + spanishLanguage" />
					</div>
				</div>

				<checkbox v-if="spanishLanguage" v-model="extraAddress" label="¿Es usted un miembro del servicio que está adquiriendo un arma de fuego en un estado donde se encuentra su lugar de destino permanente, pero reside en un estado diferente?" style="margin: 1em 0;" />
				<checkbox v-else v-model="extraAddress" label="Are you a service member who is acquiring a firearm in a State where your permanent duty station is located, but reside in a different State?" style="margin: 1em 0;" />
				<div v-show="extraAddress" class="section-b-address section-b-section three-columns media-three-two-columns">
					<div>
						<label ref="home_address_1" v-if="spanishLanguage">Número de casa y dirección de la calle</label>
						<label ref="home_address_1" v-else>Home Number and Street Address</label>
						<input type="text" v-model="form.form_data.section_b.home_address_1"/>
					</div>
					<div>
						<label ref="home_city" v-if="spanishLanguage">Ciudad natal</label>
						<label ref="home_city" v-else>Home City</label>
						<input type="text" v-model="form.form_data.section_b.home_city"/>
					</div>
					<div>
						<label ref="home_county" v-if="spanishLanguage"><b>Condado</b> / Municipalidad / Barrio natal</label>
						<label ref="home_county" v-else>Home <b>County</b> / Parish / Borough</label>
						<input type="text" v-model="form.form_data.section_b.home_county"/>
					</div>
					<div>
						<label ref="home_state" v-if="spanishLanguage">Estado natal</label>
						<label ref="home_state" v-else>Home State</label>
						<state-select type="text" v-model="form.form_data.section_b.home_state" :showApo="true" :showProvinces="true" placeHolder="Select..." ></state-select>
					</div>
					<div>
						<label ref="home_zip_code" v-if="spanishLanguage">Código postal de la casa</label>
						<label ref="home_zip_code" v-else>Home Zip Code</label>
						<input type="text" v-model="form.form_data.section_b.home_zip_code"/>
					</div>
					<div>
						<label ref="home_in_city_limits" v-if="spanishLanguage">¿Reside en los límites de la ciudad?</label>
						<label ref="home_in_city_limits" v-else>Home In City Limits?</label>
						<binary-toggle v-model="form.form_data.section_b.home_in_city_limits" :tertiary="true" :labels="spanishLanguage ? 'Sí,No,Desconocido' : 'Yes,No,Unknown'" style="margin-top:0.5em;" :key="'icl_' + spanishLanguage" />
					</div>
				</div>
			</div>

			<div style="margin: 1em 0 0 0;">
				<h2 v-if="spanishLanguage" class="small">Fecha de nacimiento, Lugar de nacimiento</h2>
				<h2 v-else class="small">Birth Date, Place of Birth</h2>
				<div class="two-columns media-two-columns">
					<div>
						<label v-if="spanishLanguage" ref="birthdate">Fecha de nacimiento</label>
						<label v-else ref="birthdate">Birth Date</label>
						<date-input v-model="form.form_data.section_b.birthdate" style="width: 13em;" />
					</div>
					<div style="margin: 0 0 1em 0;">
						<label v-if="spanishLanguage" ref="place_of_birth">Lugar de nacimiento</label>
						<label v-else ref="place_of_birth">Place of Birth</label>
						<binary-toggle v-model="form.form_data.section_b.place_of_birth" values="U,F" :labels="spanishLanguage ? 'Estados Unidos,País extranjero' : 'USA,Foreign Country'" style="margin-bottom:0.15em;" :key="'pob_' + spanishLanguage" />
					</div>
				</div>
				<div class="two-columns">
					<div>
						<div v-show="form.form_data.section_b.place_of_birth == 'U'">
							<label v-if="spanishLanguage" ref="birth_city">Ciudad y estado de nacimiento de los Estados Unidos</label>
							<label v-else ref="birth_city">US City and State of Birth</label>
							<div class="media-two-columns two-columns">
								<input type="text" v-model="form.form_data.section_b.birth_city" :placeholder="spanishLanguage ? 'Estado' : 'City'"/>
								<state-select v-model="form.form_data.section_b.pob_code"/>
							</div>
						</div>
						<div v-show="form.form_data.section_b.place_of_birth == 'F'">
							<label v-if="spanishLanguage" ref="foreign_country">País extranjero de nacimiento</label>
							<label v-else ref="foreign_country">Foreign Country of Birth</label>
							<select v-model="form.form_data.section_b.foreign_country">
								<option :value="null">Country...</option>
								<option v-for="(country, code) in this.COUNTRIES_LIST" :value="country">{{ country }}</option>
							</select>
						</div>
					</div>
					<div></div>
				</div>
			</div>

			<div style="margin: 1em 0 0 0;">
				<h2 v-if="spanishLanguage" class="small">Información del Adquiriente / Comprador</h2>
				<h2 v-else class="small">Transferee / Buyer Info</h2>
				<div class="two-columns media-two-columns">
					<div>
						<label v-if="spanishLanguage">Estatura</label>
						<label v-else>Height</label>
						<label v-if="spanishLanguage" ref="feet">Pies</label>
						<label v-else ref="feet">Feet</label>
						<number-input v-model="form.form_data.section_b.feet" decimals="0" />
						<label v-if="spanishLanguage" ref="inches">Pulgadas</label>
						<label v-else ref="inches">Inches</label>
						<number-input v-model="form.form_data.section_b.inches" decimals="0" min="0" max="11" />
						<label v-if="spanishLanguage">Peso</label>
						<label v-else>Weight</label>
						<label v-if="spanishLanguage" ref="weight">libras</label>
						<label v-else ref="weight">lbs.</label>
						<number-input v-model="form.form_data.section_b.weight" decimals="0" />
					</div>

					<div>
						<label v-if="spanishLanguage" ref="gender_code">Sexo</label>
						<label v-else ref="gender_code">Sex</label>
						<binary-toggle v-model="form.form_data.section_b.gender_code" :tertiary="true" :labels="spanishLanguage ? 'Masculino,Femenino,No Binario' : 'Male,Female,Non-Binary'" values="M,F,U" style="margin-bottom:0.15em;" :key="'gc_' + spanishLanguage" />
						<div style="margin: 1.5em 0 0 0;">
							<label v-if="spanishLanguage" ref="ssn">Número de seguro social (opcional)</label>
							<label v-else ref="ssn">Social Security Number (optional)</label>
							<input type="text" v-model="form.form_data.section_b.ssn"/>

							<label v-if="spanishLanguage" ref="upin">Número único de identificación personal (UPIN, por sus siglas en inglés) o Identificación de la base de datos del Manejo de Apelaciones (AMD ID, por sus siglas en inglés) (Si aplica)</label>
							<label v-else ref="upin">Unique Personal Identification Number (UPIN) or Appeals Management Database Identification (AMD ID) (if applicable)</label>
							<input type="text" v-model="form.form_data.section_b.upin"/>
						</div>
					</div>

				</div>
			</div>

			<div style="margin: 1em 0 0 0;">
				<h2 v-if="spanishLanguage" class="small">Etnicidad, Raza</h2>
				<h2 v-else class="small">Ethnicity, Race</h2>
				<div>
					<div style="margin: 0 0 1em 0;">
						<label v-if="spanishLanguage" ref="ethnicity">Etnicidad: Hispanic or Latino?</label>
						<label v-else ref="ethnicity">Ethnicity: Hispanic or Latino?</label>
						<binary-toggle v-model="form.form_data.section_b.ethnicity" values="hispanic,nonhispanic" :labels="spanishLanguage ? 'Sí,No' : 'Yes,No'" style="margin-bottom:0.15em;" :key="'eth_' + spanishLanguage" />
					</div>
					<label v-if="spanishLanguage" ref="customer_race">Raza (seleccione una o más razas)</label>
					<label v-else ref="customer_race">Race (select all that apply)</label>
					<div class="two-columns media-two-columns" style="grid-row-gap: 0.25em;">
						<checkbox v-model="form.form_data.section_b.customer_race.l4" :label="spanishLanguage ? 'Indio americano o nativo de Alaska' : 'American Indian or Alaska Native'" style="margin: 0.5em 0;" />
						<checkbox v-model="form.form_data.section_b.customer_race.l1" :label="spanishLanguage ? 'Asiático' : 'Asian'" style="margin: 0.5em 0;" />
						<checkbox v-model="form.form_data.section_b.customer_race.l2" :label="spanishLanguage ? 'Negro o afroamericano' : 'Black or African American'" style="margin: 0.5em 0;" />
						<checkbox v-model="form.form_data.section_b.customer_race.l5" :label="spanishLanguage ? 'Nativo de Hawai o de otras islas del Pacífico' : 'Native Hawaiian or Other Pacific Islander'" style="margin: 0.5em 0;" />
						<checkbox v-model="form.form_data.section_b.customer_race.l6" :label="spanishLanguage ? 'Blanco' : 'White'" style="margin: 0.5em 0;" />
					</div>
				</div>
			</div>

			<div style="margin: 1em 0 1em 0;">
				<h2 v-if="spanishLanguage" class="small">Ciudadanía</h2>
				<h2 v-else class="small">Citizenship</h2>
				<label v-if="spanishLanguage" ref="citizen_status_code">País de ciudadanía</label>
				<label v-else ref="citizen_status_code">Country of Citizenship</label>
				<binary-toggle v-model="form.form_data.section_b.citizen_status_code" values="C,F" :labels="spanishLanguage ? 'Estados Unidos de América (EE. UU.),Otros País/Países' : 'United States of America (U.S.A),Other Country/Countries'" style="margin-bottom:0.15em;" :key="'csc_' + spanishLanguage" />
				<div v-show="form.form_data.section_b.citizen_status_code == 'F'" class="three-columns media-three-columns" style="margin: 1em 0 0 0;">
					<div>
						<label v-if="spanishLanguage" ref="citizen_country_code">Especifique:</label>
						<label v-else ref="citizen_country_code">Specify:</label>
						<select v-model="form.form_data.section_b.citizen_country_code" ref="foreign_country">
							<option value="">Country...</option>
							<option v-for="(country, code) in this.COUNTRIES_LIST" :value="country">{{ country }}</option>
						</select>
					</div>
					<div v-if="form.form_data.section_b.citizen_country_code">
						<label v-if="spanishLanguage" ref="citizen_country_code_2">Especifique:</label>
						<label v-else ref="citizen_country_code_2">Specify:</label>
						<select v-model="form.form_data.section_b.citizen_country_code_2" ref="foreign_country">
							<option value="">Country...</option>
							<option v-for="(country, code) in this.COUNTRIES_LIST" :value="country">{{ country }}</option>
						</select>
					</div>
					<div v-if="form.form_data.section_b.citizen_country_code_2">
						<label v-if="spanishLanguage" ref="citizen_country_code_3">Especifique:</label>
						<label v-else ref="citizen_country_code_3">Specify:</label>
						<select v-model="form.form_data.section_b.citizen_country_code_3" ref="foreign_country">
							<option value="">Country...</option>
							<option v-for="(country, code) in this.COUNTRIES_LIST" :value="country">{{ country }}</option>
						</select>
					</div>
				</div>
				<div style="margin: 1em 0 0 0;">
					<label v-if="spanishLanguage" ref="mnu1">Si usted es un extranjero, escriba su número de extranjero o admisión a los Estados Unidos (AR#, #USCIS, o I94#):</label>
					<label v-else ref="mnu1">If you are an alien, record your U.S.-issued alien or admission number (AR#, USCIS#, or I94#):</label>
					<input type="text" v-model="form.form_data.section_b.mnu1"/>
					<select id="mnu_type_code1" v-model="form.form_data.section_b.mnu_type_code1" v-if="form.form_data.section_b.mnu1" style="width: 7em;">
						<option value="">Select...</option>
						<option value="AR">Alien Registration Number or USCIS</option>
						<option value="I9">Non-Immigrant Admissions Number</option>
					</select>
				</div>			
			</div>

			<h2 v-if="spanishLanguage" class="small">Conteste las siguientes preguntas seleccionando el encasillado “sí” o “no” a la derecha de cada pregunta</h2>
			<h2 v-else class="small">Answer the following questions by selecting either “yes” or “no”</h2>
			<div class="section-b-section">
				<div class="section-b-questions">
					<div class="firearm-line-number">a</div>
					<div>
						<label ref="actual_buyer" v-if="spanishLanguage">
							¿Es usted el adquiriente/comprador actual del arma(s) de fuego que figuran en este formulario y en cualquier hoja(s) de continuación (ATF Formulario 5300.9A)? <strong>Advertencia</strong>: Usted no es el adquiriente/comprador actual, si usted está adquiriendo todas arma(s) de fuego en nombre de otra persona. Si usted no es el adquiriente/comprador real, el transferidor no puede transferirle ninguna de las arma(s) de fuego a usted.
							<div class="two-one-columns" style="margin: 0.5em 0 0 0;">
								<div>Excepción: Si usted solamente va a recoger un arma(s) de fuego reparada para otra persona, usted no está obligado a responder a. y puede proceder con la pregunta b.</div>
								<checkbox v-model="form.form_data.section_b.picking_up_repaired" label="Recoger arma(s) de fuego reparada(s)" />
							</div>
						</label>
						<label ref="actual_buyer" v-else>
							Are you the actual transferee/buyer of all of the firearm(s) listed on this form and any continuation sheet(s) (ATF Form 5300.9A)? <strong>Warning:</strong> You are not the actual transferee/buyer if you are acquiring any of the firearm(s) on behalf of another person. If you are not the actual transferee/buyer, the licensee cannot transfer any of the firearm(s) to you.
							<div class="two-one-columns" style="margin: 0.5em 0 0 0;">
								<div>Exception: If you are only picking up a repaired firearm(s) for another person, you are not required to answer a. and may proceed to question b.</div>
								<checkbox v-model="form.form_data.section_b.picking_up_repaired" label="Picking up repaired firearm(s)" />
							</div>
						</label>
					</div>
					<binary-toggle v-model="form.form_data.section_b.actual_buyer" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'ab_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">b</div>
					<label ref="purchase_for_other" v-if="spanishLanguage">¿Tiene la intención de comprar o adquirir cualquier arma de fuego enumerada en este formulario y cualquier hoja de continuación o munición, para la venta o disposición a cualquier persona descrita en las preguntas c. - m. o a una persona descrita en la pregunta n. que no esté bajo una excepción de no inmigrante? </label>
					<label ref="purchase_for_other" v-else>Do you intend to purchase or acquire any firearm listed on this form and any continuation sheet(s), or ammunition, for sale or other disposition to any person described in questions c. - m., or to a person described in question n. who does not fall within a nonimmigrant alien exception?</label>
					<binary-toggle v-model="form.form_data.section_b.purchase_for_other" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'pfo_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">c</div>
					<label ref="purchase_for_felony" v-if="spanishLanguage">¿Tiene la intención de vender o disponer de cualquier arma de fuego enumerada en este formulario y cualquier hoja de continuación o munición para promover cualquier delito grave u otra ofensa punitiva con prisión por un período de más de un año, un delito Federal de terrorismo o una ofensa de tráfico de drogas? </label>
					<label ref="purchase_for_felony" v-else>Do you intend to sell or otherwise dispose of any firearm listed on this form and any continuation sheet(s) or ammunition in furtherance of any felony or other offense punishable by imprisonment for a term of more than one year, a Federal crime of terrorism, or a drug trafficking offense?</label>
					<binary-toggle v-model="form.form_data.section_b.purchase_for_felony" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'pff_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">d</div>
					<label ref="under_indictment" v-if="spanishLanguage">¿Está bajo acusación o información en cualquier tribunal por un delito grave, o cualquier otro delito por el cual el juez podría encarcelarlo durante más de un año, o es un miembro actual de las fuerzas armadas que ha sido acusado de haber violado el Código Uniforme de Justicia Militar, y cuyos cargos han sido transferidos a una corte marcial general? </label>
					<label ref="under_indictment" v-else>Are you under indictment or information in any court for a <strong>felony</strong>, or any other crime for which the judge could imprison you for more than one year, or are you a current member of the military who has been charged with violation(s) of the Uniform Code of Military Justice and whose charge(s) have been referred to a general court-martial?</label>
					<binary-toggle v-model="form.form_data.section_b.under_indictment" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'ui_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">e</div>
					<label ref="convict" v-if="spanishLanguage">¿Alguna vez ha sido condenado en un tribunal por un delito grave, incluyendo una corte militar, o cualquier otro delito por el que el juez podría haberle encarcelado por más de un año, aunque haya recibido una sentencia más corta entre ellos libertad condicionada? </label>
					<label ref="convict" v-else>Have you ever been convicted in any court, including a military court, of a <strong>felony</strong>, or any other crime for which the judge could have imprisoned you for more than one year, even if you received a shorter sentence including probation?</label>
					<binary-toggle v-model="form.form_data.section_b.convict" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'con_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">f</div>
					<label ref="fugitive" v-if="spanishLanguage">¿Es usted un fugitivo de la justicia?</label>
					<label ref="fugitive" v-else>Are you a fugitive from justice?</label>
					<binary-toggle v-model="form.form_data.section_b.fugitive" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'fug_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">g</div>
					<label ref="addict" v-if="spanishLanguage">¿Es usted un usuario ilegal de, o adicto a la marihuana o cualquier depresivo, estimulante, narcótico o cualquier otra sustancia controlada? <strong>Advertencia</strong>: El uso o posesión de marihuana sigue siendo ilegal bajo la ley federal, independientemente de si se ha legalizado o despenalizado con fines médicos o de recreo en el estado en el que usted reside. </label>
					<label ref="addict" v-else>Are you an unlawful user of, or addicted to, marijuana or any depressant, stimulant, narcotic drug, or any other controlled substance? <strong>Warning:</strong> The use or possession of marijuana remains unlawful under Federal law regardless of whether it has been legalized or decriminalized for medicinal or recreational purposes in the state where you reside.</label>
					<binary-toggle v-model="form.form_data.section_b.addict" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'add_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">h</div>
					<label ref="mental" v-if="spanishLanguage">¿Alguna vez ha sido adjudicado como deficiente mental <strong>O</strong> ha sido alguna vez admitido a una institución mental? </label>
					<label ref="mental" v-else>Have you ever been adjudicated as a mental defective <strong>OR</strong> have you ever been committed to a mental institution?</label>
					<binary-toggle v-model="form.form_data.section_b.mental" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'mental_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">i</div>
					<label ref="dishonorable_discharge" v-if="spanishLanguage">¿Ha sido despedido de las Fuerzas Armadas bajo condiciones deshonorables?</label>
					<label ref="dishonorable_discharge" v-else>Have you ever been discharged from the Armed Forces under dishonorable conditions?</label>
					<binary-toggle v-model="form.form_data.section_b.dishonorable_discharge" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'dd_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">j</div>
					<label ref="restraining_order" v-if="spanishLanguage">¿Está sujeto a algún mandato judicial por el que se le prohibe acosar, acechar o amenazar a su hijo o hija, o a su pareja, o al hijo de ésta? </label>
					<label ref="restraining_order" v-else>Are you subject to a court order, including a Military Protection Order issued by a military judge or magistrate, restraining you from harassing, stalking, or threatening your child or an intimate partner or child of such partner?</label>
					<binary-toggle v-model="form.form_data.section_b.restraining_order" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'ro_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">k</div>
					<label ref="domestic_violence" v-if="spanishLanguage">¿Alguna vez ha sido condenado en cualquier corte de un delito menor de violencia doméstica, o es, o ha sido miembro de las fuerzas armadas y ha sido convicto de algún crimen que incluye, como elemento, el uso de fuerza en contra de una persona, como indentificado en las instrucciones? </label>
					<label ref="domestic_violence" v-else>Have you ever been convicted in any court of a misdemeanor crime of domestic violence, or are you or have you ever been a member of the military and been convicted of a crime that included, as an element, the use of force against a person as identified in the instructions?</label>
					<binary-toggle v-model="form.form_data.section_b.domestic_violence" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'dv_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">l</div>
					<label ref="renounced_citizenship" v-if="spanishLanguage">¿Alguna vez ha renunciado a la ciudadanía de los Estados Unidos?</label>
					<label ref="renounced_citizenship" v-else>Have you ever renounced your United States citizenship?</label>
					<binary-toggle v-model="form.form_data.section_b.renounced_citizenship" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'rc_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">m</div>
					<label ref="illegal_alien" v-if="spanishLanguage">¿Es usted un extranjero ilegal o está ilegalmente en los Estados Unidos? </label>
					<label ref="illegal_alien" v-else>Are you an alien <strong>illegally</strong> or <strong>unlawfully</strong> in the United States?</label>
					<binary-toggle v-model="form.form_data.section_b.illegal_alien" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" style="margin-bottom:0.15em;" :key="'ia_' + spanishLanguage" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">n</div>
					<label ref="legal_alien" v-if="spanishLanguage">¿Es usted un extranjero que ha sido admitido en los Estados Unidos con una visa de no inmigrante? <strong>(Ciudadanos estadounidenses/nacionales dejen en blanco)</strong></label>
					<label ref="legal_alien" v-else>Are you an alien who has been admitted to the United States under a nonimmigrant visa? <strong>(U.S. citizens/nationals leave blank)</strong></label>
					<binary-toggle v-model="form.form_data.section_b.legal_alien" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" :disabled="form.form_data.section_b.citizen_status_code != 'F'" style="margin-bottom:0.15em;" :key="'la_' + spanishLanguage + form.form_data.section_b.legal_alien" />
				</div>
				<div class="section-b-questions">
					<div class="firearm-line-number">o</div>
					<label ref="exc_code" v-if="spanishLanguage">Si contestó “sí” a la pregunta anterior, se encuentra bajo algunas de las excepciones mencionadas en las instrucciones? <strong>(Ciudadanos estadounidenses/nacionales dejen en blanco)</strong></label>
					<label ref="exc_code" v-else>If you are such an alien do you fall within any of the exceptions stated in the instructions? <strong>(U.S. citizens/nationals leave blank)</strong></label>
					<binary-toggle v-model="form.form_data.section_b.exc_code" values="yes,no" :labels="spanishLanguage ? 'sí,no' : 'yes,no'" :disabled="form.form_data.section_b.citizen_status_code != 'F' || form.form_data.section_b.legal_alien == 'no'" style="margin-bottom:0.15em;" :key="'exc_' + spanishLanguage + form.form_data.section_b.exc_code" />
				</div>
			</div>

			<div style="margin: 1.5em 0 0 0;">
				<h2 v-if="spanishLanguage" class="small">Certificación y Firma</h2>
				<h2 v-else class="small">Certify and Sign</h2>
				<p v-if="spanishLanguage"><strong>Certifico que mis respuestas en la sección B son verdaderas, correctas y completas. He leído y entendido las notificaciones, instrucciones, y definiciones en el Formulario 4473. Entiendo que contestar “sí” a la pregunta a. si no soy el adquiriente/comprador real es castigable como un delito grave bajo la ley federal, y también puede violar leyes estatales y/o locales. Entiendo que una persona que responda “sí” a cualquiera de las preguntas b. a la m. está prohibida de recibir o poseer un arma de fuego. Entiendo que una persona que responda “sí” a la pregunta n. está prohibido recibir o poseer un arma de fuego, a menos que la persona conteste “sí” a la pregunta o. y proporcione la documentación requerida en la sección C. También entiendo que hacer cualquier declaración oral o escrita falsa, o exhibir cualquier identificación falsa o tergiversada con respecto a esta transacción, es un delito que se castiga como un delito grave bajo la ley federal, y también puede violar leyes estatales y/o locales. Además, entiendo que la compra repetitiva de armas de fuego para fines de reventa para obtener principalmente un lucro sin una licencia federal de armas de fuego es una violación de la ley federal.</strong></p>
				<p v-else><strong>I certify that my answers in Section B are true, correct, and complete. I have read and understand the Notices, Instructions, and Definitions on ATF Form 4473. I understand that answering “yes” to question a. if I am not the actual transferee/buyer is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I understand that a person who answers “yes” to any of the questions b. through m. is prohibited from receiving or possessing a firearm. I understand that a person who answers “yes” to question n. is prohibited from receiving or possessing a firearm, unless the person answers “yes” to question o. and provides the documentation required in Section C. I also understand that making any false oral or written statement, or exhibiting any false or misrepresented identification with respect to this transaction, is a crime punishable as a felony under Federal law, and may also violate State and/or local law. I further understand that the repetitive purchase of firearms for the purpose of resale to predominantly earn a profit without a Federal firearms license is a violation of Federal law.</strong></p>
				<div class="section-b-section two-columns">
					<div>
						<label ref="signature" v-if="spanishLanguage">Firma del adquiriente/comprador</label>
						<label ref="signature" v-else>Transferee’s / Buyer’s Signature</label>
						<div v-if="form.form_data.section_b.signature" style="margin: 1em 0 0 1em;">
							<img class="signature" :src="form.form_data.section_b.signature">
							<div v-if="correcting == 'B'" style="margin: 1em 0 0 0;">
								<div class="button neutral inline" @click="form.form_data.section_b.signature = ''">Clear Signature</div>
							</div>
						</div>
						<div v-else style="margin: 1em 0 0 0;">
							<signature-inputs v-model="form.form_data.section_b.new_signature" :spanishLanguage="spanishLanguage" :key="'si_' + spanishLanguage" :enableSignOnScreen="enableSignOnScreen" />
						</div>
					</div>
					<div>
						<label ref="signed_date" v-if="spanishLanguage">Fecha de certificación</label>
						<label ref="signed_date" v-else>Certification Date</label>
						<div v-if="!correcting" v-show="$route.path.indexOf('customer') > -1">
							<checkbox v-if="spanishLanguage" v-model="acceptToday" label="Marque aquí para aceptar la fecha de hoy" style="margin: 1em 0;" />
							<checkbox v-else v-model="acceptToday" label="Check here to accept today's date" style="margin: 1em 0;" />
						</div>
						<date-input v-if="correcting" v-model="form.form_data.section_b.signed_date"></date-input>
						<input v-else type="text" v-model="form.form_data.section_b.signed_date" style="width: 13em;" readonly />
					</div>
				</div>
			</div>

		</div>

		<div v-if="locked" style="position: absolute; top: 2.5em; left: 0; width: 100%; height: 100%; cursor: not-allowed;" @click="showLockedReason()"></div>

		<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

    </div>
</template>

<script>
import BinaryToggle from '@/components/BinaryToggle.vue'
import StateSelect from '@/components/StateSelectInput.vue'
import CDSDateInput from '@/components/DateInput.vue'
import NumberInput from '@/components/NumberInput.vue'
import Checkbox from '@/components/Checkbox.vue'
import SignatureInputs from '@/components/SignatureInputs.vue'
export default {
	name: 'form4473-section-b',
	props: ['form', 'spanishLanguage', 'locked', 'enableSignOnScreen', 'correcting'],
    components: {
        'binary-toggle': BinaryToggle,
		'state-select': StateSelect,
		'date-input': CDSDateInput,
		'number-input': NumberInput,
		'checkbox': Checkbox,
		'signature-inputs': SignatureInputs
	},
	data() {
		return {
			loading: false,
			extraAddress: false,
			today: '',
			todayFormatted: '',
			saving: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			acceptToday: false
		}
	},
	created() {
		let theDate = new Date()
		this.today = theDate.getFullYear() + '-' + (theDate.getMonth() + 1).toString().padStart(2,'0') + '-' + theDate.getDate().toString().padStart(2,'0')
		this.todayFormatted = (theDate.getMonth() + 1).toString().padStart(2,'0') + '/' + theDate.getDate().toString().padStart(2,'0') + '/' + theDate.getFullYear()
		if (this.form.form_data.section_b.home_address_1) {
			this.extraAddress = true
		}
	},
	mounted() {
		if (this.$route.path.indexOf('customer') == -1) {
			let mustBeNo = ['purchase_for_other', 'purchase_for_felony', 'under_indictment', 'convict', 'fugitive', 'addict', 'mental', 'dishonorable_discharge', 'restraining_order', 'domestic_violence', 'renounced_citizenship', 'illegal_alien']
			mustBeNo.forEach((reference) => {
				if (this.form.form_data.section_b[reference] == 'yes') {
					this.$refs[reference].classList.add("please-correct")
				}
			})
		}
	},
	watch: {
		'form.form_data.section_b.first_initial' (newVal) {
			if (newVal && this.form.form_data.section_b.first_name) { this.form.form_data.section_b.first_name = this.form.form_data.section_b.first_name.charAt(0) }
		},
		'form.form_data.section_b.middle_initial' (newVal) {
			console.log(newVal)
			if (newVal) { 
				this.form.form_data.section_b.no_middle_name = false
				if (this.form.form_data.section_b.middle_name) {
					this.form.form_data.section_b.middle_name = this.form.form_data.section_b.middle_name.charAt(0)
				}
			}
		},
		'form.form_data.section_b.no_middle_name' (newVal) {
			console.log(newVal)
			if (newVal) { 
				this.form.form_data.section_b.middle_initial = false
				this.form.form_data.section_b.middle_name = '' 
			}
		},
		'form.form_data.section_b.last_initial' (newVal) {
			if (newVal) {
				if (this.form.form_data.section_b.last_name) { this.form.form_data.section_b.last_name = this.form.form_data.section_b.last_name.charAt(0) }
				this.form.form_data.section_b.suffix = ''
			}
		},
		'form.form_data.section_b.county' (newVal) {
			if (['US','U.S.','USA','U.S.A.','UNITED STATES'].includes(newVal.toUpperCase())) {
				this.form.form_data.section_b.county = ''
			}
		},
		'form.form_data.section_b.citizen_status_code' (newVal) {
			if (newVal == 'C') {
				this.form.form_data.section_b.legal_alien = ''
				this.form.form_data.section_b.exc_code = ''
			}
		},
		'form.form_data.section_b.legal_alien' (newVal) {
			if (newVal == 'no') {
				this.form.form_data.section_b.exc_code = ''
			}
		},
		acceptToday (newVal) {
			if (newVal) {
				this.form.form_data.section_b.signed_date = this.todayFormatted
			} else {
				this.form.form_data.section_b.signed_date = ''
			}
		}
	},
    methods: {
		validateSection() {
			// remove any previously set error flags
			for (const [key, element] of Object.entries(this.$refs)) {
				this.removeError(element)
			}
			let data = this.form.form_data.section_b

			console.log(data)

			// require inputs
			let required = ['first_name', 'middle_name', 'last_name', 'birthdate', 'place_of_birth', 'feet', 'inches', 'weight', 'gender_code', 'ethnicity', 'citizen_status_code', 'address_1', 'city', 'county', 'state', 'zip_code', 'in_city_limits']
			if (this.extraAddress) {
				// require home address inputs
				required.push('home_address_1', 'home_city', 'home_county', 'home_state', 'home_zip_code', 'home_in_city_limits')
			}
			// require yes/no questions
			required.push('actual_buyer', 'purchase_for_other', 'purchase_for_felony', 'under_indictment', 'convict', 'fugitive', 'addict', 'mental', 'dishonorable_discharge', 'restraining_order', 'domestic_violence', 'renounced_citizenship', 'illegal_alien')
			// signature
			required.push('signed_date')
			let errorMessage = ''
			for (const [key, element] of Object.entries(this.$refs)) {
				if (required.includes(key) && !data[key]) {
					// edge cases
					if (key == 'actual_buyer' && data.picking_up_repaired) { continue }
					if (key == 'middle_name' && data.no_middle_name) { continue }
					this.applyError(element)
					errorMessage = element.textContent
					break
				}
				// edge cases
				if (key == 'place_of_birth' && data.place_of_birth == 'U' && (!data.birth_city || !data.pob_code)) {
					this.applyError(this.$refs['birth_city'])
					errorMessage = this.$refs['birth_city'].textContent
					break
				}
				if (key == 'place_of_birth' && data.place_of_birth == 'F' && !data.foreign_country) {
					this.applyError(this.$refs['foreign_country'])
					errorMessage = this.$refs['foreign_country'].textContent
					break
				}
				if (key == 'customer_race') {
					if (Object.values(data.customer_race).every(x => x === null || x === '' || x === false)) {
						this.applyError(this.$refs['customer_race'])
						errorMessage = this.$refs['customer_race'].textContent
						break
					}
				}
				if (key == 'citizen_status_code' && data.citizen_status_code == 'F' && !data.citizen_country_code) {
					this.applyError(this.$refs['citizen_country_code'])
					errorMessage = 'Specify your Country of Citizenship.'
					break
				}
				if (key == 'legal_alien' && data.citizen_status_code == 'F' && !data.legal_alien) {
					this.applyError(this.$refs['legal_alien'])
					errorMessage = this.$refs['legal_alien'].textContent
					break
				}
				if (key == 'exc_code' && data.citizen_status_code == 'F' && data.legal_alien == 'yes' && !data.exc_code) {
					this.applyError(this.$refs['exc_code'])
					errorMessage = this.$refs['exc_code'].textContent
					break
				}
				if (key == 'signature' && !data.signature) {
					if (data.new_signature) {
						data.signature = data.new_signature
						data.new_signature = ''
					} else {
						this.applyError(this.$refs['signature'])
						errorMessage = this.$refs['signature'].textContent
						break
					}
				}				
			}
			// not just blank but valid?
			if (!errorMessage) {
				if (isNaN(Date.parse(data.birthdate))) {
					this.applyError(this.$refs['birthdate'])
					errorMessage = 'Please enter a valid date'
				}
			}
			return errorMessage
		},
		applyError(element) {
			element.classList.add("please-correct")
			element.scrollIntoView( {behavior: "smooth", block: "start", inline: "nearest"} )
		},
		removeError(element) {
			element.classList.remove("please-correct")
		},
		showLockedReason() {
			this.message = 'Section B is locked because<br>'
			if (this.form.internal_use_only) {
				this.message += 'it can only be corrected <a href="/dashboard/logbooks/customer-4473" target="_blank"><b><u>in the Kiosk</u></b></a>.'
			} else if (this.form.moved_to_ffl_log_book_form_id) {
				this.message += 'it is a previous version of a corrected form.'
			} else if (this.form.form_data.section_e.seller_signature) {
				this.message += 'Section E has been signed.'
			} else if (this.form.form_data.section_b.signature) {
				this.message += 'it has been signed by the Transferee / Buyer.'
			} else if (!this.form.section_completed) {
				this.message += 'Section A has not been completed.'
			} else {
				this.message += 'it must be completed <a href="/dashboard/logbooks/customer-4473" target="_blank"><b><u>in the Kiosk</u></b></a>.'
			}
			this.messageStatus = 'alert'
		}
	}
}
</script>